// extracted by mini-css-extract-plugin
export default {"shippingIcon":"_d4b247e6","shipsFromContainer":"_5fc9c13f","shipsFrom":"_86c9b198"};